import React from 'react';
import {BreakpointProvider} from "@nutastic/nutastic-react-app";
import LinksAppWrapper from "./LinksAppWrapper";

//TODO: refactor and move to react-app project, build in standard support in NuEngine
const LinksApp = (props) => {
    return <BreakpointProvider>
        <LinksAppWrapper {...props} />
    </BreakpointProvider>;
};

export default LinksApp;
